//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { UserGroupModel } from './UserGroupModel';
  import { UserNameModel } from './UserNameModel';
  import { NotificationModel } from './NotificationModel';
  import { RoleModel } from './../../security/models/RoleModel';
  
  export class UserModel extends ModelBase {
      static readonly $typeName = 'UserModel';
      public emailAddress: string;
      public groups: UserGroupModel[];
      public identifier: string;
      public isDisabled: boolean;
      public isLocked: boolean;
      public key: string;
      public lockReason: string;
      public name: UserNameModel;
      public notifications: NotificationModel[];
      public roles: RoleModel[];
      public status: string;
      public hasUniversalGroupAccess:boolean;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/UserModel.ts